import { ReactNode, ChangeEvent } from 'react';

interface ControllerFieldCheckboxProps {
  name: string;
  label: ReactNode;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const ControllerFieldCheckbox = ({
  name,
  label,
  handleChange,
}: ControllerFieldCheckboxProps) => (
  <div className="data-collection-form" role="group">
    <input
      type="checkbox"
      id={name}
      name={name}
      aria-invalid="false"
      onChange={handleChange}
    />
    <label htmlFor={name}>
      {label}
    </label>
  </div>
);

export default ControllerFieldCheckbox;
